var indentation_default = {
  "indentZero": "aey9d",
  "indentOne": "ylYAf",
  "indentTwo": "Vkww0",
  "indentThree": "ikSgP",
  "indentFour": "PsZ4R",
  "indentFive": "yBy5N",
  "indentSix": "_6aol5"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
